<template>
    <div class="cont-vaul-strip">
        <card :class="itemCss" class="wdh-card">
            <div class="head-strip">
                PHYSICAL-{{ vault.type.replace("_", "-") }}
            </div>
            <div class="vault-strip" style="flex-wrap: wrap;">
                <ILText v-if="vault" />
                <ILValue v-if="vault" />
                <ILTransaction v-if="vault" />
            </div>
        </card>
    </div>
</template>

<script>
//import Vue from "vue";

import Card from "./../Card";
import ILText from "./ILText";
import ILValue from "./ILValue";
import ILTransaction from "./ILTransaction";

import { mapState, mapActions } from "vuex";
export default {
    name: "VaultStrip",
    components: {
        Card,
        ILText,
        ILValue,
        ILTransaction
    },
    data() {
        return {
            updateInterval: null
        };
    },
    watch: {
        "$store.state.wallet.balance": {
            handler: function(nval) {
                this.checkingToken = false;
                if (nval > 0) {
                    this.hasToken = true;
                } else {
                }
            }
        },
        vault() {
            this.initialize();
        },
        depositing() {
            this.$emit("update-vault");
        },
        withdrawing() {
            this.$emit("update-vault");
        },
        requesting() {
            this.$emit("update-vault");
        },
        toogleUpdatedVault() {
            this.init();
        }
    },
    computed: {
        ...mapState(["vaults", "wallet"]),
        ...mapState("il", [
            "vault",
            "tab",
            "depositing",
            "withdrawing",
            "requesting",
            "toogleUpdatedVault"
        ]),
        itemCss() {
            return `${this.data.color}-card`;
        }
    },
    methods: {
        ...mapActions("il", [
            "setVault",
            "setData",
            "initialize",
            "checkVaultType"
        ]),
        async init() {
            //check the vault type | wheter call or put
            const vault = await this.checkVaultType({ vault: this.data });

            this.setVault({
                ...vault,
                pQueuedDeposits: this.pQueuedDeposits,
                pQueuedWithdraws: this.pQueuedWithdraws,
                userInfo: this.userInfo
            });
        }
    },
    props: {
        data: {
            type: Object
        },
        pQueuedDeposits: {
            default: null
        },
        pQueuedWithdraws: {
            default: null
        },
        userInfo: {
            type: Object,
            default: {
                queuedDeposits: 0,
                position: 0,
                queuedWithdraw: 0,
                userScaleX1e36: 0,
                queuedEpoch: 0,
                exitQueueEpoch: 0
            }
        }
    },
    async mounted() {
        await this.init();
        if (!this.wallet.walletProvider) {
            this.setData({ key: "checkingApproval", value: false });
            this.setData({ key: "approved", value: false });

            // return;
        } else {
            await this.initialize();

            // this.updateInterval = setInterval(() => {
            //     this.$emit("update-vault");
            // }, 30000);
        }
        this.setData({ key: "premiumLoad", value: true });
    },
    beforeDestroy() {
        // clearInterval(this.updateInterval);
        this.updateInterval = null;
        //localStorage.removeItem(tabState);
    }
};
</script>
